import { useEffect, useState } from "react";

export type StepTotpResendCooldown = {
	disableNewCodeButton: boolean;
	secondsBeforeNewCode: number;
	sendAnotherCode: () => void;
};

export function useStepTotpResendCooldown(onSendAnotherCode: () => void): StepTotpResendCooldown {
	const [disableNewCodeButton, setDisableNewCodeButton] = useState(false);
	const [secondsBeforeNewCode, setSecondsBeforeNewCode] = useState(0);

	useEffect(() => {
		const interval = setInterval(() => {
			setSecondsBeforeNewCode((value) => {
				if (value <= 1) {
					setDisableNewCodeButton(false);
					return 0;
				}
				return value - 1;
			});
		}, 1000);
		return (): void => clearInterval(interval);
	}, []);

	const sendAnotherCode = (): void => {
		onSendAnotherCode();
		setDisableNewCodeButton(true);
		setSecondsBeforeNewCode(30);
	};

	return { disableNewCodeButton, secondsBeforeNewCode, sendAnotherCode };
}
